import { render, staticRenderFns } from "./selectBehaviourType.vue?vue&type=template&id=119cddd3&scoped=true"
import script from "./selectBehaviourType.vue?vue&type=script&lang=js"
export * from "./selectBehaviourType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "119cddd3",
  null
  
)

export default component.exports